.arch {
  position: relative;
  flex: none;
  aspect-ratio: 180 / 314;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 70px 70px 8px 8px;
  border: 1px solid var(--accent);
  background: linear-gradient(180deg, var(--surface), var(--bg));
  box-shadow: 0 0 30px var(--card-glow);
  color: var(--accent);
}

.numeral {
  position: absolute;
  top: 9px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 9px;
  letter-spacing: 0.26em;
}

.glyph {
  width: 54%;
}

.xs {
  width: 40px;
  border-radius: 24px 24px 4px 4px;
  box-shadow: 0 0 14px var(--card-glow);
}

.sm {
  width: 64px;
  flex-direction: column;
  justify-content: space-between;
  padding: 6px 6px 8px;
  border-radius: 34px 34px 5px 5px;
  background:
    radial-gradient(110% 70% at 50% 40%, var(--card-tint), transparent 62%),
    linear-gradient(180deg, var(--surface), var(--bg));
  box-shadow: 0 0 14px var(--card-glow);
  text-align: center;
}

.xs .numeral {
  display: none;
}

.sm .numeral {
  position: static;
  margin-top: 4px;
  font-size: 8px;
  letter-spacing: 0.12em;
  padding-left: 0.3em;
}

.sm .glyph {
  width: 70%;
  flex: 1;
  min-height: 0;
}

.md {
  width: 112px;
}

.lg {
  width: 160px;
}

.hero {
  width: 190px;
  flex-direction: column;
  justify-content: space-between;
  padding: 18px 14px 20px;
  border-radius: var(--radius-arch) var(--radius-arch) var(--radius-arch-base) var(--radius-arch-base);
  background:
    radial-gradient(110% 70% at 50% 40%, var(--card-tint), transparent 62%),
    linear-gradient(180deg, var(--surface), var(--bg));
  box-shadow: 0 0 34px var(--card-glow);
  text-align: center;
}

.hero .numeral {
  position: static;
  margin-top: 10px;
  font-size: 11px;
  letter-spacing: 0.3em;
  padding-left: 0.3em;
}

.hero .glyph {
  width: 70%;
  flex: 1;
  min-height: 0;
}

.name {
  margin: 0;
  font-family: var(--font-display);
  font-style: italic;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.15;
  color: var(--text);
}

@media (prefers-reduced-motion: no-preference) {
  .hero {
    animation: reveal 0.9s cubic-bezier(0.2, 0.7, 0.2, 1) both;
  }
}

@keyframes reveal {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
}
